import React, { useState, useEffect } from "react";
import Header from "../body/Header";
import "./Form.css";
import {
  allCountries,
  getAllCountries,
  postActivity,
} from "../../redux/reducers/countries";
import { useSelector, useDispatch } from "react-redux";
import Swal from "sweetalert2";

const Form = () => {
  let dispatch = useDispatch();
  const [span, setSpan] = useState("");
  useEffect(() => {
    dispatch(getAllCountries());
  }, [dispatch]);
  const [form, setForm] = useState({
    countries: [],
    name: "",
    difficulty: "",
    duration: "",
    season: "",
  });
  const onChangeName = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const onChangeCountries = (e) => {
    if (form.countries.length > 0 && e.target.value !== "") {
      let findCountry = form.countries.filter((c) => c === e.target.value);

      if (findCountry.length > 0) {
        setSpan("País ya seleccionado");
      } else {
        setSpan("");
        setForm({
          ...form,
          countries: [...form.countries, e.target.value],
        });
      }
    }
    if (e.target.value !== "") {
      setSpan("");

      setForm({
        ...form,
        countries: [...form.countries, e.target.value],
      });
    }
  };
  const eraseCountryList = (name) => {
    let list = form.countries.filter((c) => c !== name);

    setForm({ ...form, countries: [...list] });
  };
  const postearActivity = (e) => {
    e.preventDefault();
    dispatch(postActivity(form));
    Swal.fire({ icon: "success", title: "Complete", text: "Activity created" });
    setForm({
      name: "",
      difficulty: "",
      duration: "",
      season: "",
      countries: [],
    });
    let inputs = document.getElementsByClassName("inputs-form");

    for (let item of inputs) {
      item.value = "";
    }
  };
  let countries = useSelector(allCountries);

  return (
    <>
      <Header />
      <div className="form-container">
        <div className="form-content">
          <div className="form">
            <form onSubmit={postearActivity}>
              <div>
                <p>Activity Name: </p>
                <input
                  onChange={onChangeName}
                  type="text"
                  name="name"
                  className="inputs-form"
                />
              </div>
              <div>
                <p>Difficulty: </p>
                <input
                  onChange={onChangeName}
                  type={"number"}
                  min="1"
                  max="5"
                  name="difficulty"
                  className="inputs-form"
                />
              </div>
              <div>
                <p>Duration: </p>
                <input
                  onChange={onChangeName}
                  type="number"
                  min="1"
                  max="8"
                  name="duration"
                  className="inputs-form"
                />{" "}
              </div>
              <div>
                <p>Season: </p>
                <select
                  className="inputs-form"
                  onChange={onChangeName}
                  name={"season"}
                >
                  <option value={""}>Choose a season</option>
                  <option value={"Invierno"}>Winter</option>
                  <option value={"Primavera"}>Spring</option>
                  <option value={"Otoño"}>Fall</option>
                  <option value={"Verano"}>Summer</option>
                </select>
              </div>{" "}
              <div className="country">
                <div className="title-country">
                  <p>Countries: </p>
                  <span className="span">{span === "" ? "" : span}</span>
                </div>
                <select
                  className="inputs-form"
                  onChange={onChangeCountries}
                  name={"countries"}
                >
                  <option value={""}>Choose a country</option>
                  {Array.isArray(countries)
                    ? countries.map((coun) => (
                        <option key={coun.id} value={coun.name}>
                          {coun.name}
                        </option>
                      ))
                    : ""}
                </select>
                <ul className="list-country-container">
                  <p>Countries selected:</p>
                  {Array.isArray(form.countries)
                    ? form.countries.map((el) => (
                        <li className="list-country-map">
                          {el}
                          <button onClick={() => eraseCountryList(el)}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="15"
                              height="15"
                              viewBox="0 0 16 19"
                              fill="none"
                            >
                              <path
                                d="M11.681 2.41458C11.7194 2.55015 11.874 2.66 12.0286 2.66H15.0175C15.5603 2.66 16 3.05682 16 3.54666C16 3.95141 15.6996 4.29181 15.2906 4.39869L14.7774 17.1327C14.7358 18.1687 13.7807 19 12.6294 19H3.37062C2.22147 19 1.26424 18.1678 1.22258 17.1327L0.709425 4.39869C0.300438 4.29181 0 3.95141 0 3.54666C0 3.05682 0.439696 2.66 0.982467 2.66H3.97141C4.12602 2.66 4.28173 2.54817 4.31901 2.41458L4.52844 1.65557C4.78831 0.717461 5.80587 0 6.87606 0H9.12388C10.1952 0 11.2116 0.717436 11.4715 1.65557L11.681 2.41458ZM7.29835 6.71337V15.3267C7.29835 15.676 7.61305 15.96 8.00011 15.96C8.38718 15.96 8.70187 15.676 8.70187 15.3267V6.71337C8.70187 6.36405 8.38718 6.08004 8.00011 6.08004C7.61305 6.08004 7.29835 6.36405 7.29835 6.71337ZM4.07025 6.73217L4.35095 15.3455C4.36301 15.6948 4.68648 15.9699 5.07354 15.96C5.46061 15.9491 5.76542 15.6572 5.75448 15.3079L5.47377 6.69458C5.46171 6.34526 5.13824 6.07016 4.75118 6.08004C4.36412 6.09093 4.0593 6.38285 4.07025 6.73217ZM10.5265 6.69457L10.2458 15.3078C10.2348 15.6572 10.5396 15.9491 10.9267 15.96C11.3137 15.9699 11.6372 15.6948 11.6493 15.3454L11.93 6.73216C11.9409 6.38284 11.6361 6.09093 11.249 6.08003C10.862 6.07014 10.5385 6.34525 10.5265 6.69457ZM6.41553 2.66H9.58441C9.66117 2.66 9.70941 2.60558 9.69077 2.53829L9.56467 2.08505C9.5241 1.93661 9.29274 1.77332 9.12388 1.77332H6.87606C6.7072 1.77332 6.47583 1.93661 6.43527 2.08505L6.30917 2.53829C6.29053 2.60657 6.33877 2.66 6.41553 2.66H6.41553Z"
                                fill="#EB5757"
                              />
                            </svg>
                          </button>
                        </li>
                      ))
                    : ""}
                </ul>
                <div className="button">
                  <button
                    type="submit"
                    disabled={
                      form.name === "" ||
                      form.countries.length === 0 ||
                      form.duration === "" ||
                      form.difficulty === "" ||
                      form.season === "" ||
                      form.duration > 8 ||
                      form.difficulty > 5
                    }
                  >
                    Create Activity
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div className="image-form"></div>
        </div>
      </div>
    </>
  );
};

export default Form;
